export default __webpack_public_path__ + "static/event-designthinking-1ac83840a8311453625785bb26f8ec46.jpg";